import { useStyles } from "@b2bportal/core-themes";
import { type HsbcPortalComponent, HSBC_PORTAL_NAME } from "@hsbc/portal";

export const useHsbcPortalStyles = (
  componentName: keyof typeof HsbcPortalComponent,
  defaultStyles?: object
) => useStyles(HSBC_PORTAL_NAME, componentName, defaultStyles);
